<template>
  <div>
    <label for="ano">Ano:</label>
    <select v-model="ano" class="form-select mb-3" >
      <option value="2021">2021</option>
      <option value="2020">2020</option>
    </select>
    <div v-for="(formentos, index) in fomento"
        :key="index">
      <div class="d-flex mb-3 border border-success p-2 col-6"
        v-if="ano == formentos.ano"
      >
        <a
          target="_blank"
          :href="`http://www.saude.am.gov.br/docs/termodefomento/${formentos.numero}-${formentos.ano}/${formentos.descricao}.pdf`"
        >
         <i class="far fa-file-pdf mt-1 me-2"></i> {{ formentos.descricao }}
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      ano: '2021',
      numero: '',
      fomento: [
        {
          numero: '001',
          ano: '2020',
          descricao: 'TF nº 001-2020 APACC primitivo'
        },
        {
          numero: '001',
          ano: '2020',
          descricao: 'TF nº 001-2020 APACC apostila'
        },
        {
          numero: '002',
          ano: '2020',
          descricao: 'TF nº002-2021- APACC'
        },
        {
          numero: '003',
          ano: '2020',
          descricao: 'TF nº 003-2020 APACC primitivo'
        },
        {
          numero: '003',
          ano: '2020',
          descricao: 'TF nº 003-2020 APACC apostila'
        },
        {
          numero: '004',
          ano: '2020',
          descricao: 'TF nº 004-2020 FE primitivo'
        },
        {
          numero: '004',
          ano: '2020',
          descricao: 'TF nº 004-2020 Fazenda Esperança apostila'
        },
        {
          numero: '005',
          ano: '2020',
          descricao: 'TF nº 005 - 2020 Moacyr Alves Primitivo'
        },
        {
          numero: '005',
          ano: '2020',
          descricao: 'TF nº005-2020 Moacyr Alves Apostila'
        },
        {
          numero: '006',
          ano: '2020',
          descricao: 'TF nº 006-2020-GACC Primitivo'
        },
        {
          numero: '007',
          ano: '2020',
          descricao: 'TF nº 007-2020 - Casa Vhida Primitivo'
        },
        {
          numero: '007',
          ano: '2020',
          descricao: 'TF nº 007-2020 - Casa Vhida - Apostila'
        },
        {
          numero: '007',
          ano: '2020',
          descricao: 'TF nº 007-2020 1º T.A - Casa Vhida'
        },
        {
          numero: '007',
          ano: '2020',
          descricao: 'TF nº007-2020 2ºT.A  - Casa Vhida'
        },
        {
          numero: '008',
          ano: '2020',
          descricao: 'TF nº 008-2020 -Benefic Portuguesa -Primitivo'
        },
        {
          numero: '008',
          ano: '2020',
          descricao: 'TF nº 008-2020 -Benefic Portuguesa -Apostila'
        },
        {
          numero: '009',
          ano: '2020',
          descricao: 'TF nº 009 -2020 ADVAM - Primitivo'
        },
        {
          numero: '010',
          ano: '2020',
          descricao: 'TF nº010-2020 - FE- Primitivo'
        },
        {
          numero: '010',
          ano: '2020',
          descricao: 'TF nº010-2020 FE - Apostila'
        },
        {
          numero: '010',
          ano: '2020',
          descricao: 'TF nº010 - 2020 1º TA -FE'
        },
        {
          numero: '001',
          ano: '2021',
          descricao: 'TF nº001-2021 - CVI'
        },
        {
          numero: '002',
          ano: '2021',
          descricao: 'TF nº002-2021- APACC'
        }
      ]
    }
  }
}
</script>

<style>
</style>
